/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OverviewUserResource { 
    id: number;
    firstName: string;
    lastName: string;
    email: string;
}

